import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import cookie from "react-cookies";
import axios from "utils/axios";
import { Rating } from "@mui/material";
import MainLayout from "layout/MainLayout";
import { TopAds } from "../Contents";
import { getDate } from "utils/utils";

const UserDashboard = () => {
  const [activities, setActivities] = useState<Array<any>>([]);
  const [favourites, setFavourites] = useState<Array<any>>([]);
  const [reviews, setReviews] = useState<Array<any>>([]);
  const [resources, setResources] = useState<Array<any>>([]);
  const { title: username } = cookie.load("user");
  const navigate = useNavigate();
  const { tokenId } = useParams<string>();

  useEffect(() => {
    getActivity(Number(tokenId));
    getFavourite(Number(tokenId));
    getReview(Number(tokenId));
    getResource();
  }, [tokenId]);

  const getResource = async () => {
    const result = await axios.get("/api/resource/getAllResourceName");
    setResources(result.data);
  };

  const getActivity = async (tokenId: number) => {
    const result = await axios.get(`/api/activity/getByTokenId/${tokenId}`);
    setActivities(result.data);
  };

  const getFavourite = async (tokenId: number) => {
    const result = await axios.get(`/api/favourite/getByTokenId/${tokenId}`);
    setFavourites(result.data);
  };

  const getReview = async (tokenId: number) => {
    const result = await axios.get(`/api/review/getByTokenId/${tokenId}`);
    setReviews(result.data);
  };

  const getResourceName = (favourite: any) => {
    for (let resource of resources) {
      if (resource.id === favourite.resourceId) {
        return resource.name;
      }
    }
  };

  return (
    <MainLayout title="My Profile">
      <div className="containers my-16 sm:my-[24px] flex lg:flex-col md:flex-col sm:flex-col gap-10">
        <div className="flex gap-10 lg:flex-col md:flex-col sm:flex-col grow">
          <div className="flex xl:flex-col xl:w-[225px] gap-4">
            <img
              src={cookie.load("user")?.media}
              alt="background"
              className="w-[225px] h-[150px] sm:w-[135px] sm:h-[90px] object-cover"
            />
            <div className="flex flex-col grow">
              <div className="flex flex-col gap-3">
                <h4 className="sm:text-2xl sm:leading-[24px]">
                  {reviews[0]?.username}
                </h4>
                <span className="text-xl leading-[32px] font-[#4C4C4C] sm:text-[16px] sm:leading-[20px]">
                  Role:{" "}
                  {
                    (cookie.load("user").title =
                      reviews[0]?.username &&
                      (cookie.load("user")?.userType === "admin"
                        ? "Admin"
                        : cookie.load("user")?.userType === "super_user"
                        ? "Super User"
                        : "User"))
                  }
                  <br />
                </span>
              </div>
              <button className="main-button mt-auto ml-auto xl:mt-3 xl:ml-0 sm:hidden">
                <Link to="/create-resource">CREATE A RESOURCE</Link>
              </button>
            </div>
          </div>
          <button className="main-button mt-auto ml-auto xl:mt-3 xl:ml-0 hidden sm:block mx-auto">
            <Link to="/create-resource">CREATE A RESOURCE</Link>
          </button>
          <div className="grid gap-5">
            <div>
              <h4 className="mb-5">Activity Feed</h4>
              {activities.map((activity, index) => (
                <p
                  className="text-lg font-opensans font-light leading-[40px]"
                  key={index}
                >
                  <span className="pr-2">{getDate(activity.date)}</span>
                  <span
                    className="pr-2 hover:text-[#3498db] cursor-pointer"
                    onClick={() => {
                      if (
                        cookie.load("user")?.organization.toLowerCase() ===
                        "gyde"
                      )
                        navigate(`/profile/${activity.tokenId}`);
                    }}
                  >
                    {activity.username === username ? "You" : activity.username}
                  </span>
                  <span className="pr-2">{activity.activityType}</span>
                  <span
                    className="pr-2 hover:text-[#3498db] cursor-pointer"
                    onClick={() => {
                      if (
                        cookie.load("user")?.organization.toLowerCase() ===
                        "gyde"
                      )
                        navigate(`/view-resource?id=${activity.resourceId}`);
                    }}
                  >
                    {activity.resourceName}
                  </span>
                  <span
                    className="pr-2 hover:text-[#3498db] cursor-pointer"
                    onClick={() => {
                      if (
                        cookie.load("user")?.organization.toLowerCase() ===
                        "gyde"
                      )
                        navigate(
                          `/search/${activity.resourceType.toLowerCase()}`
                        );
                    }}
                  >{`(${activity.resourceType})`}</span>
                  {activity.rating && (
                    <span>{`with ${activity.rating} stars`}</span>
                  )}
                </p>
              ))}
            </div>
            <div>
              <h4 className="mb-5">Favorites</h4>
              {favourites.map((favourite, index) => (
                <p
                  className="text-lg font-opensans font-light leading-[40px] tracking-[0.6px] hover:text-[#3498db] cursor-pointer"
                  onClick={() => {
                    if (
                      cookie.load("user")?.organization.toLowerCase() === "gyde"
                    )
                      navigate(`/view-resource?id=${favourite.resourceId}`);
                  }}
                  key={index}
                >
                  {getResourceName(favourite)}
                </p>
              ))}
            </div>
            <div>
              <h4 className="mb-5">Reviews</h4>
              {reviews.map((review, index) => (
                <p
                  className="text-lg font-opensans font-light leading-[28px] tracking-[0.6px] mb-4"
                  onClick={() => {
                    navigate(`/view-resource?id=${review.resourceId}`);
                  }}
                  key={index}
                >
                  {getDate(review.date) + " " + review.organization}
                  <br />
                  <Rating value={review.rating} readOnly />
                  <br />
                  {review.content}
                </p>
              ))}
            </div>
          </div>
        </div>
        <TopAds />
      </div>
    </MainLayout>
  );
};

export default UserDashboard;
